import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import { GenerateAddressLabelURL, getSession, processEmail, processInt, processNum, processStrWithSpace, valdiatePage } from "../../global";
import { getLocations, getAreas, getSubAccountLocations } from '../../services/userservice';
import { getServiceGuide, save, getCustomerInfo } from '../../services/bookingservice';
import './booking.css';
import MemoDestinationsDDL from '../../components/memoDestinationsDDL';
import { setLoading } from '../../redux/appSlice'
import { useDispatch, useSelector } from "react-redux";
import AlertModal from "../../components/alertmodal";
import SearchAbleList from "../../components/searchableList";

const Booking = () => {
    const dispatch = useDispatch();
    const { loading, userInfo, destinations, subaccounts, types, services } = useSelector(state => state.appData);
    const d = {
        cn: '',
        cnType: '12',
        consignee: '',
        consigneeAddress: '',
        consigneePhone: '',
        consigneeEmail: '',
        destination: '',
        area: '',
        //destinationName: '',
        pcs: '1',
        serviceType: '',
        weight: '',
        productDetails: '',
        remarks: '',
        refNo: '',
        codAmount: '0',
        shs: true,
        departmentCostCenter: '',
        locationId: '',
        //subAccountId: '',
        subAccountId: '',
        autoCN: null,
        //isCod: types && types.length > 0 ? types[0].value == 1 : null,
        isCod: null,
        accountNo: '',
        lat: '',
        long: '',
        branch: '',
        w: '',
        l: '',
        h: '',
        denseWeight: '',
        rt: null
    };

    const [data, setData] = useState(d);
    const [serviceGuide, setServiceGuide] = useState(null);
    const [locations, setLocations] = useState([]);
    const [areas, setAreas] = useState([]);
    const destRef = useRef(null);
    const [sr, setSr] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [response, setResponse] = useState({})


    const history = useHistory();


    useEffect(() => {
        if (!valdiatePage('/booking')) {
            history.push('/login');
        }
    }, []);

    useEffect(() => {
        if (data.destination) {
            getAreas(data.destination).then(rs => {
                if (rs.sts == 0) {
                    setAreas(rs.data);
                } else {
                    setAreas([]);
                }
            });
        } else {
            setAreas([]);
        }
    }, [data.destination]);

    useEffect(() => {
        if (data.branch && data.destination) {
            const z = {
                branchCode: data.branch,
                //destination: data.destinationName || destinations.find(x => x.value == data.destination).text,
                destination: destinations.find(x => x.value == data.destination).text,
                type: data.isCod ? 1 : 0
            }
            getServiceGuide(z).then(rs => {
                if (rs.ok)
                    setServiceGuide(rs.data);
                else
                    setServiceGuide(null);
            })
        }
    }, [data.branch, data.destination]);

    useEffect(() => {
        const dw = +data.denseWeight;
        const w = ((+data.l) * (+data.w) * (+data.h)) / 5000;
        if (w > dw)
            updateData('weight', w);
        else
            updateData('weight', dw);
    }, [data.l, data.w, data.h, data.denseWeight]);

    useEffect(() => {
        const load = async () => {
            const iscod = types && types.length > 0 ? types[0].value == 1 : null;
            const dsa = subaccounts.find(x => x.isCod == iscod && x.isDefault);
            const d = { ...data, isCod: iscod, subAccountId: '', locationId: '', branch: '', autoCN: null, accountNo: '' };
            if (dsa) {
                d.subAccountId = dsa.id;
                d.autoCN = dsa.autoCN;
                d.accountNo = dsa.accountNo;
                // const locs = await getLocations(userInfo.id, dsa.accountNo);
                const locs = await getSubAccountLocations(userInfo?.id, dsa.id);
                if (locs) {
                    setLocations(locs);
                    const dl = locs.find(x => x.isDefault);
                    if (dl) {
                        d.locationId = dl.value;
                        d.branch = dl.branch;
                    }
                }
            }
            setData(d);
        }

        load();
    }, []);

    const validate = (u) => {
        //Consignee Name is Required
        //Consignee Address is Required
        //Consignee Mobile No is Required
        //Destination City is Required
        //Pieces is Required
        //Ref No is Required
        //Service is Required
        //Consignee Name Length Must be Less than or Equals to 50
        //Consignee Address Length Must be Less than or Equals to 255
        //Consignee Email Length Must be Less than or Equals to 50
        //Product Detail Length Must be Less than or Equals to 600
        //Ref No Length Must be Less than or Equals to 50
        //Pieces Must be Greater than to 0
        //Weight Must be Greater than to 0
        //Max Alowed Weight Exceeds (9999)
        //Max Alowed Weight Exceeds (99)
        //COD amount must be greater than 0
        if (!data.subAccountId) {
            alert('Sub Account is required');
            return false;
        }

        if (!data.locationId) {
            alert('Location is required');
            return false;
        }

        if (data.autoCN == false && !data.cn) {
            alert('Consignment No is required');
            return false;
        }


        if (!data.consignee || data.consignee.trim() === '') {
            alert('Consignment Name is required');
            return false;
        }

        if (data.isCod) {
            if (!data.consigneePhone) {
                alert('Consignment Phone is required');
                return false;
            } else {
                if (data.consigneePhone.length < 11) {
                    alert('Consignment Phone is Invalid');
                    return false;
                }
            }
        }

        if (data.consigneeEmail.trim() && !data.consigneeEmail.includes('@')) {
            alert('Consignment Email is invalid');
            return false;
        }

        if (!data.consigneeAddress || data.consigneeAddress.trim() === '') {
            alert('Consignment Address is required');
            return false;
        }

        if (!data.serviceType) {
            alert('Select Service Type');
            return false;
        }

        if (!data.destination) {
            alert('Please select correct destination.');
            return false;
        }

        // if (data.isCod && !userInfo.isZeroCodAllowed) {
        //     if (!data.codAmount || data.codAmount <= 0) {
        //         alert('Cod Amount must be greater than 0');
        //         return false;
        //     } else if (data.codAmount > 99999) {
        //         alert('Cod Amount must be less than 99999');
        //         return false;
        //     }
        // }

        if (data.isCod) {

            if (!userInfo.isZeroCodAllowed) {
                if (+data.codAmount <= 0) {
                    alert('Cod Amount must be greater than 0');
                    return false;
                }
            }



            const codAmountLimit = getSession('codAmountLimit');


            const amountLimitCheck = codAmountLimit?.length > 0 && codAmountLimit?.filter(i => i.accountNo.toUpperCase() == data.accountNo.toUpperCase());
            let codAmountL = 99999;
            if(amountLimitCheck.length > 0) {
                codAmountL = amountLimitCheck[0].amount;
            }

            if (+data.codAmount > codAmountL) {
                alert(`Cod Amount must be less than ${codAmountL}`);
                return false;
            }
        }

        if (!data.weight || data.weight <= 0) {
            alert('Weight is required');
            return false;
        } else {

            let maxAllowedWeight = data.isCod ? 99 : 9999;

            const codWeightLimits = getSession('codWeightLimit');

            const accountWeightLimit = codWeightLimits?.find(
                limit => limit.accountNo.toUpperCase() === data.accountNo.toUpperCase()
            );

            if (accountWeightLimit) {
                maxAllowedWeight = Math.max(maxAllowedWeight, accountWeightLimit.weight);
            }

            // Debug log 

            if (data.weight > maxAllowedWeight) {
                alert(`Weight must not exceed ${maxAllowedWeight} kg.`);
                return false;
            }
        }

        if (!data.pcs || data.pcs <= 0) {
            alert('Pieces is required');
            return false;
        }


        if (data.isCod && !data.refNo) {
            alert('Ref No is required');
            return false;
        }

        return true;
    }

    const reset = () => {
        setData(prev => {
            return { ...d, subAccountId: prev.subAccountId, accountNo: prev.accountNo, locationId: prev.locationId, isCod: prev.isCod, autoCN: prev.autoCN, branch: prev.branch, serviceType: prev.serviceType };
        });
        setServiceGuide(null);
        destRef.current.selectedIndex = 0;
        destRef.current.value = '';
    }

    const onSave = async () => {
        const u = getSession('userInfo');
        if (validate(u)) {
            const z = {
                cn: data.autoCN ? null : data.cn,
                cnType: data.cnType,
                consignee: data.consignee,
                consigneeAddress: data.consigneeAddress,
                consigneePhone: data.consigneePhone,
                consigneeEmail: data.consigneeEmail,
                destination: data.destination,
                area: data.area,
                pcs: data.pcs,
                serviceType: data.serviceType,
                weight: data.weight,
                productDetails: data.productDetails,
                remarks: data.remarks,
                refNo: data.refNo,
                codAmount: data.isCod ?  data.codAmount ? data.codAmount : null : 0,
                shs: data.shs,
                departmentCostCenter: data.isCod ? null : data.departmentCostCenter,
                user: {
                    id: userInfo.id,
                    isDuplicateOrderAllowed: userInfo.isDuplicateOrderAllowed
                },
                locationId: data.locationId,
                subAccountId: data.subAccountId,
                autoCN: data.autoCN,
                accountNo: data.accountNo,
                departmentOrCostCenter: data.departmentOrCostCenter,
                serviceAreaType: Number(data.serviceAreaType),
                lat: Number(data.lat),
                long: Number(data.long)
            };
            dispatch(setLoading({ data: true }));
            const rs = await save(z);
            dispatch(setLoading({ data: false }));
            setResponse(rs)
            setShowModal(true)
        }
    }

    const generateLabel = () => {
        const uId = getSession('userId');
        const u = getSession('userInfo');
        var win = window.open(`${GenerateAddressLabelURL}userid=${uId}&pass=${u.password}&cn=${response.msg.substring(0, 15)}`, '_blank');
        win.focus();
        reset();
        setShowModal(false)
    }

    const updateData = (key, val) => setData(prevState => { return { ...prevState, [key]: val }; });

    const onCNBlur = (e) => {
        if (data.locationId) {
            const val = e.target.value;
            if (val) {
                const num = Number(val);
                const sequnce = getSession('sequences').filter(x => x.locationId == data.locationId)[0];
                const start = Number(sequnce.sequenceStart);
                const end = Number(sequnce.sequenceEnd);
                if (!(num >= start && num <= end)) {
                    alert('Invalid Consignment No');
                    setData({ ...data, cn: '' });
                }
            }
        } else {
            alert('Select Location');
            setData({ ...data, cn: '' });
        }
    }

    const onConsigneePhoneBlur = async (e) => {
        const val = e.target.value;
        if (val) {
            dispatch(setLoading({ data: true }));
            const rs = await getCustomerInfo(val);
            dispatch(setLoading({ data: false }));
            if (rs.ok) {
                const dsAvailable = destinations.filter(x => x.value == rs.data.destinationId);
                setData(prev => {
                    return {
                        ...prev,
                        consignee: rs.data.name,
                        consigneeAddress: rs.data.address,
                        rt: rs.data.returnTendency,
                        destination: dsAvailable.length > 0 ? rs.data.destinationId : '',
                        lat: rs.data.lat,
                        long: rs.data.long
                    }
                })
                const z = destinations.find(x => x.value == rs.data.destinationId);
                if(dsAvailable.length > 0) {
                    destRef.current.value = z?.text;
                    setSr(services.filter(x => z.isExpressCargo ? true : x !== 'Express Cargo'));
                }
            }
        }
    }

    return getSession('userInfo') && <section className="section">
                <datalist id="searchablelist" >
                    {
                        destinations.map((x, index) => <option key={index} value={x.text} location={x.value} ec={`${x.isExpressCargo}`} branch={x.branchCode} />)
                    }
                </datalist>
                <datalist id="searchablelist2" >
                    {
                        destinations.map((x, index) => <option key={index} value={x.text} location={x.value} ec={`${x.isExpressCargo}`} branch={x.branchCode} />)
                    }
                </datalist>
                <div className="section-header">
                    <h1>Booking</h1>
                </div>
                {showModal && <AlertModal onSecondClick={generateLabel} response={response} setShowModal={setShowModal} reset={reset}/>}
                <div className="card" style={{ padding: 10 }}>
                    <div className="row">
                        <div className="col-lg-4 col-xl-3">
                            <label>Type</label>
                            <select className="form-select" value={data.isCod ? 1 : 0} onChange={async (e) => {
                                const iscod = e.target.value == 1;
                                const dsa = subaccounts.find(x => x.isCod == iscod && x.isDefault);
                                const d = { ...data, isCod: iscod, locationId: '', branch: '', subAccountId: '', autoCN: null };
                                if (dsa) {
                                    d.subAccountId = dsa.id;
                                    d.autoCN = dsa.autoCN;
                                    // const locs = await getLocations(userInfo.id, dsa.accountNo);
                                    const locs = await getSubAccountLocations(userInfo.id, dsa.id);
                                    if (locs) {
                                        setLocations(locs);
                                        const dl = locs.find(x => x.isDefault);
                                        if (dl) {
                                            d.locationId = dl.value;
                                            d.branch = dl.branch;
                                        }
                                    }
                                } else {
                                    setLocations([]);
                                }
                                setData(d);
                            }}>
                                {
                                    types.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                                }
                            </select>
                        </div>
                        <div className="col-lg-4 col-xl-3">
                            <label>Sub Account</label>
                            <select className="form-select" value={data.subAccountId}
                                onChange={async (e) => {
                                    const val = e.target.value;
                                    const autoCn = e.target[e.target.selectedIndex].getAttribute('data-autocn');
                                    const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                                    const d = { ...data, subAccountId: val, locationId: '', branch: '', autoCN: autoCn ? autoCn === 'true' : null, accountNo: accno };
                                    if (val) {
                                        const locs = await getSubAccountLocations(userInfo.id, val)

                                        // const locs = await getLocations(userInfo.id, accno)
                                        if (locs) {
                                            setLocations(locs);
                                            const dl = locs.find(x => x.isDefault);
                                            if (dl) {
                                                d.locationId = dl.value;
                                                d.branch = dl.branch
                                            }
                                        }
                                    } else {
                                        setLocations([]);
                                    }
                                    setData(d);
                                }}>
                                <option value="" data-autocn={null} data-accno="">Select Sub Account</option>
                                {
                                    subaccounts.filter(x => x.isCod == data.isCod).map((x, index) => <option key={index} value={x.id} data-autocn={x.autoCN} data-accno={x.accountNo}>{x.name}</option>)
                                }
                            </select>
                        </div>
                        <div className="col-lg-4 col-xl-3">
                            <label>Locations</label>
                            <select className="form-select" value={data.locationId} onChange={(e) => {
                                const val = e.target.value;
                                const branch = e.target[e.target.selectedIndex].getAttribute('data-branch');
                                setData({ ...data, locationId: val, branch: branch });
                            }}>
                                <option value="" data-branch={""}>Select Location</option>
                                {
                                    locations.map((x, index) => <option key={index} value={x.value} data-branch={x.branch}>{x.text}</option>)
                                }
                            </select>
                        </div>
                        {
                            data.autoCN == false && <div className="col-lg-4 col-xl-3">
                                <label>Consignment Number</label>
                                <input type="text" maxLength={15} className="form-control" onInput={processInt} value={data.cn} onChange={(e) => updateData('cn', e.target.value)} onBlur={onCNBlur} />
                            </div>
                        }
                    </div>
                    <div className="row mt-3">
                        <div className="col-lg-3 col-sm-12">
                            <label>Consignee Phone</label>
                            <input type="text" className="form-control" maxLength={['1m221', '1m222'].includes(data.accountNo.toLowerCase()) ? 20 : 11} value={data.consigneePhone} onInput={processInt} onBlur={onConsigneePhoneBlur} onChange={(e) => updateData('consigneePhone', e.target.value)} />
                        </div>
                        <div className="col-lg-3 col-sm-12">
                            <label>Consignee Name</label>
                            <input type="text" className="form-control" maxLength={50} value={data.consignee} onChange={(e) => updateData('consignee', e.target.value)} />
                        </div>
                        <div className="col-lg-3 col-sm-12">
                            <label>Consignee Email</label>
                            <input type="text" className="form-control" maxLength={50} value={data.consigneeEmail} onInput={processEmail} onChange={(e) => updateData('consigneeEmail', e.target.value)} />
                        </div>
                        {
                            data.rt && data.rt > 0 &&
                            <div className="col-lg-3 col-sm-12">
                                <label>Return Tendency</label>
                                <p style={{ color: '#f26522' }}>{data.rt}%, customer is likely to accept order</p>
                            </div>
                        }
                    </div>
                    <div className="row mt-3">
                        <div className="col-lg">
                            <label>Destination</label>
                            <SearchAbleList 
                                destRef={destRef}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    let location = '';
                                    let ec = false;

                                    let dt = document.getElementById('searchablelist');
                                    // dt contains a HTMLCollection of options so use for loop to iterate it use childElementCount to get the length if loop
                                    for (let i = 0; i < dt.childElementCount; i++) {
                                        // check the selected value with option values.
                                        if (dt.children[i].attributes.value.value === val) {
                                        // if Hit use the attributes object to find your attribute and get its value.
                                            location = dt.children[i].attributes.location.value;
                                            ec = (dt.children[i].attributes.ec.value === 'true');
                                        }
                                    }

                                    setData(prev => {
                                        return { ...prev, destination: location, serviceType: "" };
                                    });

                                    setSr(services.filter(x => ec ? true : x !== 'Express Cargo'));
                                }} 
                                filterOptions={() => {
                                    
                                    const originalOptions = Array.from(document.getElementById('searchablelist2').options);                            
                                    const input = document.getElementById('search');
                                    const filter = input.value.toLowerCase();
                                    const datalist = document.getElementById('searchablelist');
                            
                                    // Clear the current options
                                    datalist.innerHTML = '';
                            
                                    // Add only matching options from the originalOptions array
                                    originalOptions.forEach(option => {
                                        if (option.value.toLowerCase().startsWith(filter)) {
                                            const newOption = document.createElement('option');
                                            newOption.value = option.value;
                                            newOption.setAttribute("ec", option.getAttribute("ec"));
                                            newOption.setAttribute("branch", option.getAttribute("branch"));
                                            newOption.setAttribute("location", option.getAttribute("location"));
                                            datalist.appendChild(newOption);
                                        }
                                    });
                                }}
                            />
                        </div>
                        <div className="col-lg">
                            <label>Area</label>
                            <select className="form-select" value={data.area} onChange={(e) => updateData('area', e.target.value)}>
                                <option value="">Select Area</option>
                                {
                                    areas.map((x, index) => <option key={index} value={x}>{x}</option>)
                                }
                            </select>
                        </div>
                        <div className="col-lg">
                            <label>Service Guide</label>
                            {
                                function () {
                                    let c = "";
                                    if (serviceGuide != null)
                                        c = `Type = ${serviceGuide.status}, Additional Charges upto 5KG = ${serviceGuide.addchrgsuptO5KG}, Extra Days = ${serviceGuide.extraDays}`;
                                    return <input type="text" className="form-control" value={c} readOnly />
                                }()
                            }
                        </div>
                        <div className="col-lg">
                            <label>Latitude</label>
                            <input type="text" className="form-control" value={data.lat} onInput={processNum} onChange={(e) => updateData('lat', e.target.value)} />
                        </div>
                        <div className="col-lg">
                            <label>Longitude</label>
                            <input type="text" className="form-control" value={data.long} onInput={processNum} onChange={(e) => updateData('long', e.target.value)} />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <label>Consignee Address</label>
                            <textarea className="form-control" maxLength={255} value={data.consigneeAddress} onChange={(e) => updateData('consigneeAddress', e.target.value)}></textarea>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-lg">
                            <label>Service Type</label>
                            <select className="form-select" value={data.serviceType} onChange={(e) => updateData('serviceType', e.target.value)}>
                                <option value="">Select Service</option>
                                {
                                    sr.map((x, index) => <option key={index} value={x}>{x}</option>)
                                }
                            </select>
                        </div>
                        <div className="col-lg">
                            <label>Special Handling</label>
                            <select className="form-select" value={data.cnType} onChange={(e) => updateData('cnType', e.target.value)}>
                                <option value="13">Yes</option>
                                <option value="12">No</option>
                            </select>
                        </div>
                        <div className="col-lg-7">
                            <div className="row">
                                <div className="col-lg">
                                    <label>Dense Weight</label>
                                    <input type="text" className="form-control" value={data.denseWeight} onChange={(e) => updateData('denseWeight', e.target.value)} />
                                </div>
                                <div className="col-lg-2">
                                    <label>W</label>
                                    <input type="text" className="form-control" value={data.w} onChange={(e) => updateData('w', e.target.value)} />
                                </div>
                                <div className="col-lg-2">
                                    <label>H</label>
                                    <input type="text" className="form-control" value={data.h} onChange={(e) => updateData('h', e.target.value)} />
                                </div>
                                <div className="col-lg-2">
                                    <label>L</label>
                                    <input type="text" className="form-control" value={data.l} onChange={(e) => updateData('l', e.target.value)} />
                                </div>
                                <div className="col-lg">
                                    <label>Pieces</label>
                                    <input type="text" className="form-control" maxLength={2} value={data.pcs} onInput={processInt} onChange={(e) => updateData('pcs', e.target.value)} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        {
                            data.isCod &&
                            <div className="col-lg-auto col-sm-12">
                                <label>COD Amount</label>
                                <input type="text" className="form-control" value={data.codAmount} onInput={processNum} onChange={(e) => updateData('codAmount', Math.round(e.target.value))} />
                            </div>
                        }
                        <div className="col-lg-auto col-sm-12">
                            <label>Customer Ref No</label>
                            <input type="text" className="form-control" maxLength={20} value={data.refNo} onChange={(e) => updateData('refNo', e.target.value)} />
                        </div>
                        <div className="col-lg-7 col-sm-12">
                            <div className="row">
                                <div className="col-lg col-sm-12">
                                    <label>Product Detail</label>
                                    <textarea className="form-control" maxLength={600} value={data.productDetails} onChange={(e) => updateData('productDetails', e.target.value)}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-12">
                            <label>Remarks</label>
                            <textarea className="form-control" maxLength={200} value={data.remarks} onChange={(e) => updateData('remarks', e.target.value)}></textarea>
                        </div>
                    </div>
                    <div className="row mt-3">
                        {
                            data.isCod == false && <div className="col-lg-4 col-sm-12">
                                <label>Department/CostCenter</label>
                                <input type="text" className="form-control" maxLength={50} value={data.departmentCostCenter} onInput={processStrWithSpace} onChange={(e) => updateData('departmentCostCenter', e.target.value)} />
                            </div>
                        }
                        <div className="col" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                            <button type="button" className="btn btn-primary" disabled={loading} onClick={onSave}>Save</button>
                        </div>
                    </div>
                </div>
            </section >


}

export default Booking;